export const DATA_TEST_TAG = 'link-button';
export const ANGULAR_DATA_TEST_TAG = 'angular-link-button';
